import { theme } from '@chakra-ui/react';

export const button = {
	baseStyle: {
		py: '7px',
		fontWeight: 'bold',
	},
	sizes: {
		'h-md': {
			h: '39px',
			fontSize: '0.75rem',
			borderRadius: '0.25rem',
		},
	},
	variants: {
		solid: {
			color: theme.colors.white,
			backgroundColor: 'action',
		},
		outline: {
			color: theme.colors.white,
			borderColor: 'action',
			borderWidth: '2px',
		},
		outlineWhite: {
			color: theme.colors.white,
			borderColor: theme.colors.white,
			borderWidth: '2px',
		},
		ghost: {
			color: theme.colors.white,
		},
		hoverable: {
			_hover: {
				backgroundColor: 'accentSubtle',
			},
			_disabled: {
				opacity: '1',
			},
		},
	},
};
